import React, { forwardRef, useRef, useCallback } from 'react';
import cn from 'classnames';
import { useVisibleOptions, isGroup } from '../../utils.js';
import mergeRefs from 'react-merge-refs';
import { Optgroup } from '../optgroup/Component.js';

var styles = {"optionsList":"select__optionsList_t2b5s","emptyPlaceholder":"select__emptyPlaceholder_t2b5s","l":"select__l_t2b5s","xl":"select__xl_t2b5s"};
require('./index.css');

var createCounter = function () {
    var count = 0;
    // eslint-disable-next-line no-plusplus
    return function () { return count++; };
};
var OptionsList = forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 's' : _b, className = _a.className, Option = _a.Option, _c = _a.options, options = _c === void 0 ? [] : _c, _d = _a.Optgroup, Optgroup$1 = _d === void 0 ? Optgroup : _d, dataTestId = _a.dataTestId, emptyPlaceholder = _a.emptyPlaceholder, _e = _a.visibleOptions, visibleOptions = _e === void 0 ? 5 : _e, onScroll = _a.onScroll, open = _a.open;
    var listRef = useRef(null);
    var counter = createCounter();
    var renderGroup = useCallback(function (group) { return (React.createElement(Optgroup$1, { label: group.label, key: group.label, size: size }, group.options.map(function (option) { return Option({ option: option, index: counter() }); }))); }, [Option, counter, size]);
    useVisibleOptions({
        visibleOptions: visibleOptions,
        listRef: listRef,
        open: open,
        invalidate: options,
    });
    if (options.length === 0 && !emptyPlaceholder) {
        return null;
    }
    return (React.createElement("div", { className: cn(styles.optionsList, styles[size], className), "data-test-id": dataTestId, ref: mergeRefs([listRef, ref]), onScroll: onScroll },
        options.map(function (option) {
            return isGroup(option) ? renderGroup(option) : Option({ option: option, index: counter() });
        }),
        emptyPlaceholder && options.length === 0 && (React.createElement("div", { className: styles.emptyPlaceholder }, emptyPlaceholder))));
});

export { OptionsList };
